/**
 * TkAddToCart — botón "+ Agregar" que:
 * 1. Hace POST AJAX a /cart/add.js con sections necesarias
 * 2. Dispara CartAddEvent para que el cart drawer nativo de Horizon lo escuche
 * 3. Maneja estados (loading, success, error) con feedback visual
 */
class TkAddToCart extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('button[type="submit"]');
    if (!this.form || !this.button) return;
    this.form.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this.handleSubmit);
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    if (this.button.disabled) return;
    const originalText = this.button.textContent;
    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    this.button.textContent = '…';

    try {
      // Recolectar section IDs a refrescar (cart drawer + cualquier cart items que haya en la página)
      const cartItems = document.querySelectorAll('cart-items-component');
      const sectionIds = [];
      cartItems.forEach((el) => {
        const sid = el.dataset.sectionId;
        if (sid && !sectionIds.includes(sid)) sectionIds.push(sid);
      });

      // Preparar payload como FormData (igual que el form nativo)
      const formData = new FormData(this.form);
      if (sectionIds.length) {
        formData.set('sections', sectionIds.join(','));
        formData.set('sections_url', window.location.pathname);
      }

      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({ description: 'Error al agregar' }));
        throw new Error(err.description || err.message || 'Error al agregar');
      }
      const data = await res.json();

      // Obtener cart actualizado
      const cartRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      const cart = await cartRes.json();

      // Dispatchar CartAddEvent nativo de Horizon para que el drawer se actualice y abra
      // Formato esperado: detail.data.sections[sectionId] = html
      const detail = {
        resource: cart,
        sourceId: this.dataset.productId || '',
        data: {
          source: 'tk-add-to-cart',
          productId: this.dataset.productId,
          variantId: formData.get('id'),
          itemCount: cart.item_count,
          sections: data.sections || {},
        },
      };
      const event = new CustomEvent('cart:update', { bubbles: true, detail });
      document.dispatchEvent(event);
      // También disparar el CartAddEvent específico que usan los componentes nativos
      const addEvent = new CustomEvent('cart:add', { bubbles: true, detail });
      document.dispatchEvent(addEvent);

      // Feedback visual success
      this.button.textContent = '✓ Agregado';
      setTimeout(() => {
        this.button.textContent = originalText;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }, 1500);
    } catch (err) {
      console.error('[tk-add-to-cart]', err);
      this.button.textContent = 'Error';
      setTimeout(() => {
        this.button.textContent = originalText;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }, 2000);
    }
  };
}

if (!customElements.get('tk-add-to-cart')) {
  customElements.define('tk-add-to-cart', TkAddToCart);
}
